// Modules
import React from 'react';
import {connect} from 'react-redux';
import SingleMatchHistoryPlayer from './singleMatchHistoryPlayer';

export function singleMatchHistory(props){
    let RosterComps = Object.keys(props.roster).map((player, index)=>{
        // Solve Total Strokes
        let playerScoreArray = props.roster[player];
        let totalStrokes = 0;
        playerScoreArray.forEach(number=>{
            totalStrokes += number;
            console.log(player);
        });

        return <SingleMatchHistoryPlayer gamertag={player}
                                         teeScore_01={props.roster[player][0]}
                                         teeScore_02={props.roster[player][1]}
                                         teeScore_03={props.roster[player][2]}
                                         teeScore_04={props.roster[player][3]}
                                         teeScore_05={props.roster[player][4]}
                                         teeScore_06={props.roster[player][5]}
                                         teeScore_07={props.roster[player][6]}
                                         teeScore_08={props.roster[player][7]}
                                         teeScore_09={props.roster[player][8]}
                                         teeScore_10={props.roster[player][9]}
                                         teeScore_11={props.roster[player][10]}
                                         teeScore_12={props.roster[player][11]}
                                         teeScore_13={props.roster[player][12]}
                                         teeScore_14={props.roster[player][13]}
                                         teeScore_15={props.roster[player][14]}
                                         teeScore_16={props.roster[player][15]}
                                         teeScore_17={props.roster[player][16]}
                                         teeScore_18={props.roster[player][17]}
                                         scoreTotal={totalStrokes}
                                         key={index}
        />
    });

    return(
        <div>
            <div>
                <table>
                    <tbody>
                        <tr style={{borderBottom: "1px solid black"}}>
                            <th>Tees:</th>
                            <th>01 &#9900;</th>
                            <th>02 &#9900;</th>
                            <th>03 &#9900;</th>
                            <th>04 &#9900;</th>
                            <th>05 &#9900;</th>
                            <th>06 &#9900;</th>
                            <th>07 &#9900;</th>
                            <th>08 &#9900;</th>
                            <th>09 &#9900;</th>
                            <th>10 &#9900;</th>
                            <th>11 &#9900;</th>
                            <th>12 &#9900;</th>
                            <th>13 &#9900;</th>
                            <th>14 &#9900;</th>
                            <th>15 &#9900;</th>
                            <th>16 &#9900;</th>
                            <th>17 &#9900;</th>
                            <th>18</th>
                        </tr>
                        {RosterComps}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// Props Mapping
const mapStateToProps = state => ({
    roster: state.match.roster
});
export default connect(mapStateToProps)(singleMatchHistory);



// WEBPACK FOOTER //
// ./src/comps/singleMatchHistory.js